import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import useUser from '../../../Hooks/useUser';
import AdminBox from '../../Utility/AdminBox';
import AdminBoxHeadline from '../../Utility/AdminBoxHeadline';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import PaginatedView from "../../Utility/PaginatedView";
import {PaginationListType} from "../../../Types/PaginationParams";

function User() {
    const { UserActions, userSnapshot, userLoaded, getGroupsByUser, i18n, maxCosts } = useUser();
    const navigate = useNavigate();

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <AdminBox contentLoaded={userLoaded}>
                        <AdminBoxHeadline
                            headLine={i18n.translate({ id: 'editUser', sourceName: 'Users' })}
                            subLine={userSnapshot?.givenName + ' ' + userSnapshot?.familyName}
                        />

                        <h5>{i18n.translate({id: 'settings', sourceName: 'Users'})}</h5>

                        <label htmlFor="maxCosts" className="flex flex-col gap-2">
                            {i18n.translate({ id: 'user.maxCosts', sourceName: 'Users' })}
                            <div>
                                <Input
                                    inputType="number"
                                    value={maxCosts ?? '0'}
                                    onChange={UserActions.handleMaxCostChange}
                                    inputProps={{ min: 0, step: 0.1 }}
                                    id="maxCosts"
                                />
                                <span className="block mt-3">
                                    ({i18n.translate({ id: 'user.maxCosts.hint', sourceName: 'Users' })})
                                </span>
                            </div>
                        </label>
                    </AdminBox>

                    <AdminBox contentLoaded={userLoaded} classString={'gap-1'}>
                        <h5 className={"mt-0 mb-3"}>{i18n.translate({id: 'groups', sourceName: 'Users'})}</h5>
                        <PaginatedView
                            listType={PaginationListType.Groups}
                            listClassName="gap-3 flex flex-col pt-5"
                            itemsFunction={getGroupsByUser}
                            itemsPerPage={15}
                            renderItem={(group: any, index) => (
                                <div key={index} className="grid grid-cols-[minmax(157px,300px),minmax(157px,1fr)] cursor-pointer gap-3 py-2 px-4 rounded-lg hover:bg-chatlist-item-background-hover">
                                    <div className="w-full flex items-center text-ellipsis overflow-hidden">
                                        <span>{group.title}</span>
                                    </div>
                                    <div className="flex gap-1 justify-end items-center">
                                        <Button
                                            variant="secondaryRound"
                                            onClick={() => {
                                                navigate(`/admin/groups/${group.identifier}`);
                                            }}
                                        >
                                            <ArrowRightIcon size={20} />
                                        </Button>
                                    </div>
                                </div>
                            )}
                        >
                            {({ list, filter }) => (
                                <>
                                    {filter}
                                    {list}
                                </>
                            )}
                        </PaginatedView>
                    </AdminBox>
                </div>
                <div className="mt-5 text-right">
                    <Button onClick={UserActions.handleSave}>{i18n.translate({ id: 'save' })}</Button>
                </div>
            </AdminContainer>
        </div>
    );
}

export default User;
